import { TICKET_MANAGEMENT_TYPES } from '@constants/actionTypes/ticketActionTypes';

export const INITIAL_STATE = {
    isAuthorisedUser: true,
    ticketId: null,
    isConfidential: false,
    loaded: false,
};

export default (state = INITIAL_STATE, action = {}) => {
    switch (action.type) {
        case TICKET_MANAGEMENT_TYPES.SET_TICKET_SAH_INFO: {
            const payload = action.payload || {};
            const { confidential, isConfidential, isAuthorisedUser, ticketId } = payload;
            return {
                ...state,
                ...(isAuthorisedUser !== undefined ? { isAuthorisedUser } : {}),
                ...(ticketId !== undefined ? { ticketId } : {}),
                isConfidential: (isConfidential !== undefined ? isConfidential : confidential) ?? false,
                loaded: true,
            };
        }
        case TICKET_MANAGEMENT_TYPES.RESET_TICKET_SAH_INFO:
            return INITIAL_STATE;
        default:
            return state;
    }
};
